import React from "react";

/**
 * Must stay in sync with the `ready_selectors` value for `helpsupp` in
 * origin-web-router's microsites.json - the crawler waits on this exact string,
 * and a mismatch on either side means it waits forever with no error.
 */
export const PAGE_CONTENT_LOADED_MARKER = "page-content-loaded";

interface IPrerenderReadyMarkerProps {
  isReady: boolean;
}

/**
 * Marks the point at which a page's async content has finished loading, via a
 * `[data-id="page-content-loaded"]` element the prerender crawler waits on as its
 * ready selector (see origin-web-router's microsites.json `helpsupp` config).
 */
export const PrerenderReadyMarker = ({
  isReady,
}: IPrerenderReadyMarkerProps): JSX.Element | null =>
  isReady ? <div data-id={PAGE_CONTENT_LOADED_MARKER} hidden /> : null;
